import { FaGoogle, FaFacebookF, FaChartLine } from "react-icons/fa";
import { SiGoogleads } from "react-icons/si";
import "../styles/marketingicons.css";

function MarketingIcons() {
  const services = [
    { icon: <SiGoogleads size={40} />, title: "Google Ads" },
    { icon: <FaFacebookF size={40} />, title: "Facebook" },
    { icon: <FaChartLine size={40} />, title: "Analytics" },
    { icon: <FaGoogle size={40} />, title: "Google" },
  ];

  return (
    <section className="marketing-icon-section">
      <div className="container px-4 px-lg-5 pb-3">
        <div className="row gx-4 gy-5">
          {services.map((service, index) => (
            <div key={index} className="col-6 col-md-6 col-lg-3 text-center">
              <div className="marketing-icon-box">
                <div className="marketing-icon">{service.icon}</div>
                <h3 className="marketing-icon-title">{service.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="curved-divider">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#ffffff"
            d="M0,70 C360,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default MarketingIcons;
